module.exports = __webpack_public_path__ + "img/help_01.c2a36285.png";